/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ガス契約情報
 */
export interface Szoa304aRequestGasConInfo { 
    /**
     * 受入地点コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C300950」のユーザコードを設定
     */
    acsptPointCode: string;
    /**
     * 託送契約番号：英数字
     */
    cnsgmtCtrNo: string;
    /**
     * 託送供給契約約款区分コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C300960」のユーザコードを設定
     */
    chargeCategCode: string;
}

